import { User, NotificationPayload } from 'src/graphql/generated/graphql';
import { TFunction } from 'i18next';

export const parseNotification = (
  notification: Partial<NotificationPayload>,
  options: { t: TFunction; currentUser: User },
) => {
  const { t, currentUser } = options;
  const isNotificationAboutCurrentUser = (
    notification.data.affectedUserIds || []
  ).includes(currentUser.id);

  const notificationName = notification.name;
  const enumToTranslate = isNotificationAboutCurrentUser
    ? `${notificationName}:self`
    : `${notificationName}`;

  return {
    name: t(`notifications.transcriptions.${enumToTranslate}.name`, {
      ...(notification.data || {}),
      defaultValue: notification.name,
      interpolation: {
        escapeValue: false,
      },
    }) as string,
    description: t(
      `notifications.transcriptions.${enumToTranslate}.description`,
      {
        ...(notification.data || {}),
        defaultValue: notification.description,
        interpolation: {
          escapeValue: false,
        },
      },
    ) as string,
  };
};
